import { registerSchema } from "yage/components/ComponentRegistry";
import { Component, Schema } from "yage/decorators/type";

@Component("TreeType")
export class TreeTypeSchema extends Schema {}

registerSchema(TreeTypeSchema);
